import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=571d0686&"
import script from "./channelItem.js?vue&type=script&lang=js&"
export * from "./channelItem.js?vue&type=script&lang=js&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports